import { useTreatments } from '@splitsoftware/splitio-react'

export const useSplit = (key: string) => {
  const SplitTreatment = useTreatments([key])
  const isFeatureEnabled = SplitTreatment[key].treatment === 'on'
  return isFeatureEnabled
}
